'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { useState } from 'react';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { IoSearchOutline } from 'react-icons/io5';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';

export const ProductMainImage = ({ product }: { product: ProductDetailData }) => {
  const selectedVariant = useVariantsStore(state => state.selectedVariant);

  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState([]);

  const handleOpenGallery = (images: any[], index: number) => () => {
    if (Array.isArray(images) && images.length > 0) {
      // Ensure the images are sorted starting from the clicked index
      const reorderedImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(reorderedImages);
      setIsOpen(true);
    }
  };

  const images = selectedVariant?.images?.length ? selectedVariant.images : product.images || [];

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      {images.length > 0 && (
        <button
          type="button"
          aria-label={product.name}
          onClick={handleOpenGallery(images, 0)}
          className="relative h-[215px] w-full cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 sm:h-[350px] lg:h-[450px] xl:h-[556px]"
        >
          <div className="absolute right-4 top-4 z-20 flex min-h-10 min-w-10 items-center justify-center bg-primary text-white lg:min-h-12 lg:min-w-12 xl:min-h-[54px] xl:min-w-[54px]">
            <IoSearchOutline className="h-5 w-5 sm:h-6 sm:w-6" />
          </div>
          <Image
            src={
              product.variants && product.variants.length > 0 ? images[0]?.url : product.image.url
            }
            alt={resolveImageAlt(
              product?.variants && product?.variants?.length > 0 ? images?.[0] : product?.image,
              product?.name,
            )}
            fill
            sizes="(min-width: 1024px) 55vw, (min-width: 768px) 50vw, 100vw"
            style={{ objectFit: 'contain', objectPosition: 'center' }}
            className="absolute inset-0 z-0 h-full w-full"
          />
        </button>
      )}
    </>
  );
};
